import { render, staticRenderFns } from "./wxLinkList.vue?vue&type=template&id=69fdd3bf&scoped=true&"
import script from "./wxLinkList.vue?vue&type=script&lang=js&"
export * from "./wxLinkList.vue?vue&type=script&lang=js&"
import style0 from "./wxLinkList.vue?vue&type=style&index=0&id=69fdd3bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69fdd3bf",
  null
  
)

export default component.exports